/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "Scribd has made many excellent contributions to the Delta Lake ecosystem including connectors that make it easy to read data from various sources into Delta Lakes."), "\n", React.createElement(_components.p, null, "This talk discusses the ", React.createElement(_components.a, {
    href: "https://github.com/delta-io/kafka-delta-ingest"
  }, "kafka-delta-ingest"), " connector that enabled Scribd to reduce data ingestion costs by 95%."), "\n", React.createElement("iframe", {
    width: "560",
    height: "315",
    src: "https://www.youtube.com/embed/do4jsxeKfd4",
    title: "YouTube video player",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowFullScreen: true
  }), "\n", React.createElement(_components.p, null, "There’s also a tech talk where Scribd talks about delta-rs and kafka-delta-ingest, two Delta Lake ecosystem projects that they originally authored."), "\n", React.createElement("iframe", {
    width: "560",
    height: "315",
    src: "https://www.youtube.com/embed/mLmsZ3qYfB0",
    title: "YouTube video player",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowFullScreen: true
  }));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
